import { environment } from '../../../environments/environment';

export const withTreeShakableDevTools = environment.storeWithDevTools;
